import React from 'react'
import MaterialSymbol from '../material-symbol'

const ShowChart = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="show_chart" {...props} />
))

ShowChart.displayName = 'ShowChart'

export default ShowChart
